import { render, staticRenderFns } from "./CelestialQuoteBackground.vue?vue&type=template&id=3f7bcfc0&scoped=true"
import script from "./CelestialQuoteBackground.vue?vue&type=script&lang=js"
export * from "./CelestialQuoteBackground.vue?vue&type=script&lang=js"
import style0 from "./CelestialQuoteBackground.vue?vue&type=style&index=0&id=3f7bcfc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7bcfc0",
  null
  
)

export default component.exports